import { createSlice } from "@reduxjs/toolkit";
import {
  generateOTP,
  userLogin,
  userLoginWithGoogle,
  userLogout,
  userSignup,
} from "./services/login.services";

const initialState = {
  loading: false,
  googleLoading: false,
  error: "",
  data: null,
  userDetails: {
    firstName: localStorage.getItem("first_name") || "",
    lastName: localStorage.getItem("last_name") || "",
    mobileNo: localStorage.getItem("mobile_no") || "",
    userGuid: localStorage.getItem("user_guid") || "",
    userid: localStorage.getItem("user_id") || "",
    // isEmailVerified: localStorage.getItem("is_email_verified") || "",
  },
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setUserDetails(state, action) {
      state.userDetails = {
        ...state.userDetails,
        ...action.payload,
      };
    },
  },
  extraReducers(builder) {
    builder.addCase(generateOTP.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(generateOTP.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(generateOTP.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(userLogout.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(userLogout.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(userLogout.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(userSignup.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(userSignup.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(userSignup.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(userLogin.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(userLogin.fulfilled, (state, action) => {
      state.loading = false;
      state.userDetails.firstName = action.payload?.first_name || "";
      state.userDetails.lastName = action.payload?.last_name || "";
      state.userDetails.mobileNo = action.payload?.mobile_no || "";
      state.userDetails.userGuid = action.payload?.user_guid || "";
      state.userDetails.userid = action.payload?.ID || "";

      // Update local storage with user details
      localStorage.setItem("first_name", state.userDetails.firstName);
      localStorage.setItem("last_name", state.userDetails.lastName);
      localStorage.setItem("mobile_no", state.userDetails.mobileNo);
      localStorage.setItem("user_guid", state.userDetails.userGuid);
      localStorage.setItem("user_id", state.userDetails.userid);
      localStorage.setItem(
        "is_email_verified",
        action.payload?.is_email_verified
      );
      localStorage.setItem(
        "is_mobile_verified",
        action.payload?.is_mobile_verified
      );
      localStorage.setItem("login_with", action.payload?.login_with);
    });
    builder.addCase(userLogin.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(userLoginWithGoogle.pending, (state) => {
      state.googleLoading = true;
      state.error = "";
    });
    builder.addCase(userLoginWithGoogle.fulfilled, (state, action) => {
      state.googleLoading = false;
      state.userDetails.firstName = action.payload?.first_name || "";
      state.userDetails.lastName = action.payload?.last_name || "";
      state.userDetails.mobileNo = action.payload?.mobile_no || "";
      state.userDetails.userGuid = action.payload?.user_guid || "";
      state.userDetails.userid = action.payload?.ID || "";

      // Update local storage with user details
      localStorage.setItem("first_name", state.userDetails.firstName);
      localStorage.setItem("last_name", state.userDetails.lastName);
      localStorage.setItem("mobile_no", state.userDetails.mobileNo);
      localStorage.setItem("user_guid", state.userDetails.userGuid);
      localStorage.setItem("user_id", state.userDetails.userid);
      localStorage.setItem(
        "is_email_verified",
        action.payload?.is_email_verified
      );
      localStorage.setItem(
        "is_mobile_verified",
        action.payload?.is_mobile_verified
      );
      localStorage.setItem("login_with", action.payload?.login_with);
    });
    builder.addCase(userLoginWithGoogle.rejected, (state, action) => {
      state.googleLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { setUserDetails } = loginSlice.actions;

export default loginSlice.reducer;
